import type { QueryClient } from '@tanstack/react-query';

import { AssignmentKey } from './keys';

export const invalidateAssignedAssignments = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    queryKey: [AssignmentKey.ASSIGNED_ASSIGNMENTS],
  });
  queryClient.invalidateQueries({
    queryKey: [AssignmentKey.ASSIGNED_ASSIGNMENTS_INFINITE],
  });
};
